import * as tslib_1 from "tslib";
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { InterfaceService } from '@app/interfaces';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CustomerJobTemplateService = /** @class */ (function (_super) {
    tslib_1.__extends(CustomerJobTemplateService, _super);
    function CustomerJobTemplateService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.CustomerJobNavData = new BehaviorSubject('');
        _this.CustomerJobNavData$ = _this.CustomerJobNavData.asObservable();
        _this.whoIsViewing = new BehaviorSubject('');
        _this.$whoIsViewing = _this.whoIsViewing.asObservable();
        _this.getTeamMembersList = function (teamId) {
            return this.http.post(this.getApiUrl("get_team_members/" + teamId));
        };
        return _this;
    }
    CustomerJobTemplateService.prototype.addJobNew = function (type, customerId, data) {
        return this.http.post(this.getApiUrl("customers/" + type + "/" + customerId + "/job/new_jobs"), JSON.stringify(data));
    };
    CustomerJobTemplateService.prototype.editJob = function (type, customerId, jobId, data) {
        return this.http.post(this.getApiUrl("customers/" + type + "/" + customerId + "/jobs/" + jobId + "/update"), JSON.stringify(data));
    };
    CustomerJobTemplateService.prototype.createContact = function (customerId, data) {
        return this.http.post(this.getApiUrl("customers/" + customerId + "/create_contact_add"), JSON.stringify(data));
    };
    CustomerJobTemplateService.prototype.getSkills = function (jobId, params) {
        return this.http.get(this.getApiUrl("search_skills_description?jobId=" + jobId, params));
    };
    CustomerJobTemplateService.prototype.getSearchSkills = function (jobDescId) {
        return this.http.get(this.getApiUrl("get_assigned_skills?type=job_description&primaryId=" + jobDescId));
    };
    CustomerJobTemplateService.prototype.getDefaultJobDescriptions = function (jobDescId) {
        return this.http.get(this.getApiUrl("default_job_values/" + jobDescId));
    };
    CustomerJobTemplateService.prototype.getJobDescriptionPricingItem = function (jobDescId, params) {
        return this.http.get(this.getApiUrl("getJobDescriptionPricingItem/" + jobDescId, params));
    };
    CustomerJobTemplateService.prototype.getAssets = function (propertyId, assetId, jobId) {
        return this.http.get(this.getApiUrl("get_job_asset_details?propertyId=" + propertyId + "&jobId=" + jobId + "&assetId=" + assetId));
    };
    CustomerJobTemplateService.prototype.getContactPerference = function (contactId) {
        return this.http.get(this.getApiUrl("diary_jobservice_preference_validation?contactID=" + contactId));
    };
    CustomerJobTemplateService.prototype.getJDCustomTemplates = function (action, jobDescId, tablePKID, propertyID) {
        return this.http.get(this.getApiUrl("listCustomConfigTemplates?screenMode=addCustomTemplates&action=" + action + "&objects=Jobs&objectTypes=JobDescription&objectTypeID=" + jobDescId + "&propertyID=" + propertyID + "&tablePKID=" + tablePKID));
    };
    CustomerJobTemplateService.prototype.getInvoiceCatCustomTemplates = function (action, invCatId, tablePKID, propertyID) {
        return this.http.get(this.getApiUrl("listCustomConfigTemplates?screenMode=addCustomTemplates&action=" + action + "&objects=Jobs&objectTypes=InvoicesCategory&objectTypeID=" + invCatId + "&propertyID=" + propertyID + "&tablePKID=" + tablePKID));
    };
    CustomerJobTemplateService.prototype.checkInvCatCustomTemplatesAVl = function (invCatId, tablePKID, propertyID) {
        return this.http.get(this.getApiUrl("checkPropertyCustomTemplatesAnsAvl?screenMode=addCustomTemplates&objects=Jobs&objectTypes=InvoicesCategory&objectTypeID=" + invCatId + "&propertyID=" + propertyID + "&tablePKID=" + tablePKID));
    };
    CustomerJobTemplateService.prototype.checkJobDescCustomTemplatesAVl = function (jobDescId, tablePKID, propertyID) {
        return this.http.get(this.getApiUrl("checkPropertyCustomTemplatesAnsAvl?screenMode=addCustomTemplates&objects=Jobs&objectTypes=JobDescription&objectTypeID=" + jobDescId + "&propertyID=" + propertyID + "&tablePKID=" + tablePKID));
    };
    CustomerJobTemplateService.prototype.confirmDeleteCustomTemplatesAnswer = function (params) {
        return this.http.post(this.getApiUrl("confirmDeleteCustomTemplatesAnswer"), JSON.stringify(params));
    };
    CustomerJobTemplateService.prototype.getJobCertificatesUserColumns = function (params) {
        return this.http.post(this.getApiUrl("job_certificates_user_columns"), JSON.stringify(params));
    };
    CustomerJobTemplateService.prototype.deleteJobCertificate = function (data) {
        return this.http.post(this.getApiUrl("delete_job_view_certificate"), data);
    };
    CustomerJobTemplateService.prototype.getCustomerJobNavDetails = function (id, type, jobId) {
        var url = this.getApiUrl("customers/" + type + "/" + id + "/job/" + jobId + "/views");
        return this.http.get(url);
    };
    CustomerJobTemplateService.prototype.getJobViewCounts = function (id, type, jobId) {
        var url = this.getJobApiUrl("customers/" + type + "/" + id + "/jobs/" + jobId + "/view");
        return this.http.get(url);
    };
    CustomerJobTemplateService.prototype.getJobViewTabCounts = function (id, type, jobId, tab) {
        var url = this.getJobApiUrl("customers/" + type + "/" + id + "/jobs/" + jobId + "/view/tab-counts");
        var params = new HttpParams();
        if (tab) {
            params = params.set('tab', tab);
        }
        return this.http.get(url, { params: params });
    };
    CustomerJobTemplateService.prototype.setCustomerJobNavData = function (data) {
        this.CustomerJobNavData.next(data);
    };
    CustomerJobTemplateService.prototype.updateCustomerJobNavData = function (data) {
        var currentData = this.CustomerJobNavData.getValue() || {};
        this.CustomerJobNavData.next(tslib_1.__assign({}, currentData, data));
    };
    CustomerJobTemplateService.prototype.getJobInvoices = function (id, type, jobId, pageNum, limit) {
        var url = this.getApiUrl("customers/" + type + "/" + id + "/jobs/" + jobId + "/invoices/views?pageNumInvoices=" + pageNum + "&limitInvoices=" + limit);
        return this.http.get(url);
    };
    CustomerJobTemplateService.prototype.getJobInvoicesList = function (id, type, jobId, pageNum, limit) {
        var url = this.getApiUrl("customers/" + type + "/" + id + "/jobs/" + jobId + "/invoices/list?pageNumInvoices=" + pageNum + "&limitInvoices=" + limit);
        return this.http.get(url);
    };
    CustomerJobTemplateService.prototype.getJobDraftInvoicesList = function (id, type, jobId, pageNum, limit) {
        var url = this.getApiUrl("customers/" + type + "/" + id + "/jobs/" + jobId + "/draft_invoices/list?pageNumDraftInvoices=" + pageNum + "&limitDraftInvoices=" + limit);
        return this.http.get(url);
    };
    CustomerJobTemplateService.prototype.updateWhoIsViewing = function (availableUsers) {
        this.whoIsViewing.next(availableUsers);
    };
    CustomerJobTemplateService.prototype.getPipelineStagesList = function (pipelineId) {
        var url = this.getApiUrl("getPipelineStagesList/" + pipelineId);
        return this.http.get(url);
    };
    CustomerJobTemplateService.prototype.getTeamList = function (teamId) {
        var url = this.getApiUrl("getTeamList/" + teamId);
        return this.http.get(url);
    };
    CustomerJobTemplateService.prototype.getJobAssetLinkedOnsiteTask = function (jobId, assetIds) {
        return this.http.get(this.getApiUrl("check_job_assets_linked_onsite_taks/" + jobId + "?&assetId=" + assetIds));
    };
    CustomerJobTemplateService.ngInjectableDef = i0.defineInjectable({ factory: function CustomerJobTemplateService_Factory() { return new CustomerJobTemplateService(i0.inject(i1.HttpClient)); }, token: CustomerJobTemplateService, providedIn: "root" });
    return CustomerJobTemplateService;
}(InterfaceService));
export { CustomerJobTemplateService };
